import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 21,
  label: "省市申请量分析",
  chart: charts.chinaMap,
  definition: {
    rowDims: [{ name: "applicantProvince", label: "省", needTotal: true }],
    colDims: [],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    condition: {
      items: [
        {
          name: "applicantProvince",
          operator: "NOT_NULL",
        },
      ],
    },
  },
  chartOption: {
    chartType: ChartType.GEO,
    title: "省市申请量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false,
  },
};
